const Archive = () => (
  <>
    <path
      fill="currentColor"
      d="M6 8.005a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356A.49.49 0 0 1 6 7.005h12q.212 0 .356.144a.49.49 0 0 1 .144.356q0 .213-.144.357a.48.48 0 0 1-.356.143zM8 5.12a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.356q0-.213.144-.357A.48.48 0 0 1 8 4.12h8q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356A.48.48 0 0 1 16 5.12zM18.753 10a1.5 1.5 0 0 1 1.465 1.825l-1.382 6.217A2.5 2.5 0 0 1 16.396 20H7.603a2.5 2.5 0 0 1-2.44-1.958l-1.382-6.217A1.5 1.5 0 0 1 5.247 10zM5.247 11a.5.5 0 0 0-.488.608l1.38 6.217A1.5 1.5 0 0 0 7.605 19h8.792a1.5 1.5 0 0 0 1.464-1.175l1.381-6.217a.5.5 0 0 0-.488-.608zM14 13.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
    />
  </>
)
export default Archive
